
import { unAuthorizedPost } from "../../services";
import { LOGIN_WITH_OTP, LOGIN_WITH_OTP_USER, SEND_OTP, SEND_OTP_USER } from "../../graphql";
import { LOGIN_SUCCESS, LOGOUT, TOGGLE_LOADING, USER_LOGIN_SUCCESS, USER_LOGOUT } from "../types";

export const sendOtp = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        try {
            let apiResponse = await unAuthorizedPost("", {
                query: SEND_OTP,
                variables: requestData,
            });

            if (apiResponse.data.customStatus) {
                // let {
                //     send_otp: { message },
                // } = apiResponse.data.data;
                dispatch({ type: TOGGLE_LOADING, payload: false });
                return true;
            } else {
                dispatch({ type: TOGGLE_LOADING, payload: false });
                return false;
            }
        } catch (error) {
            console.error(error);
            dispatch({ type: TOGGLE_LOADING, payload: false });
            return false;
        }
    };
};

export const sendOtpUser = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        try {
            let apiResponse = await unAuthorizedPost("", {
                query: SEND_OTP_USER,
                variables: requestData,
            });

            if (apiResponse.data.customStatus) {
                // let {
                //     send_otp: { message },
                // } = apiResponse.data.data;
                dispatch({ type: TOGGLE_LOADING, payload: false });
                return true;
            } else {
                dispatch({ type: TOGGLE_LOADING, payload: false });
                return false;
            }
        } catch (error) {
            console.error(error);
            dispatch({ type: TOGGLE_LOADING, payload: false });
            return false;
        }
    };
};

export const loginWithOtp = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        try {
            let apiResponse = await unAuthorizedPost("", {
                query: LOGIN_WITH_OTP,
                variables: requestData,
            });

            if (apiResponse.data.customStatus) {
                let {
                    login_with_otp: { token },
                } = apiResponse.data.data;

                dispatch(logoutUser())
                dispatch({
                    type: LOGIN_SUCCESS,
                    payload: token,
                });

                dispatch({ type: TOGGLE_LOADING, payload: false });
                return true;
            }
            dispatch({ type: TOGGLE_LOADING, payload: false });
        } catch (error) {
            console.error(error);
            dispatch({ type: TOGGLE_LOADING, payload: false });
            return false;
        }
    };
};

export const loginWithOtpUser = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        try {
            let apiResponse = await unAuthorizedPost("", {
                query: LOGIN_WITH_OTP_USER,
                variables: requestData,
            });

            console.log(apiResponse)
            if (apiResponse.data.customStatus) {
                let {
                    login_with_otp_user: { token },
                } = apiResponse.data.data;
                dispatch(logout())
                dispatch({
                    type: USER_LOGIN_SUCCESS,
                    payload: token,
                });

                dispatch({ type: TOGGLE_LOADING, payload: false });
                return true;
            }
            dispatch({ type: TOGGLE_LOADING, payload: false });
        } catch (error) {
            console.error(error);
            dispatch({ type: TOGGLE_LOADING, payload: false });
            return false;
        }
    };
};

export const logoutUser = () => {
    return (dispatch) => {
        dispatch({ type: USER_LOGOUT });
    };
};

export const logout = () => {
    return (dispatch) => {
        dispatch({ type: LOGOUT });
    };
};
